// Service Template Form Schema for FormBuilder
export const createServiceTemplateSchema = {
  initialValues: {
    name: '',
    description: '',
    service_type: 'hosting',
    default_price: 0,
    billing_period: 'annual',
    features: '',

    is_active: true
  },
  
  validationRules: {
    name: {
      required: true,
      minLength: 2,
      message: 'Το όνομα προτύπου είναι υποχρεωτικό (τουλάχιστον 2 χαρακτήρες)'
    },
    service_type: {
      required: true,
      message: 'Ο τύπος υπηρεσίας είναι υποχρεωτικός'
    },
    default_price: {
      required: true,
      min: 0,
      message: 'Η τιμή πρέπει να είναι μεγαλύτερη ή ίση με 0'
    }
  },
  
  sections: [
    {
      title: 'Βασικά Στοιχεία',
      fields: [
        {
          name: 'name',
          label: 'Όνομα Προτύπου',
          type: 'text',
          required: true,
          size: 8
        },
        {
          name: 'service_type',
          label: 'Τύπος Υπηρεσίας',
          type: 'select',
          required: true,
          size: 4,
          options: [
            { value: 'development', label: 'Ανάπτυξη' },
            { value: 'hosting', label: 'Hosting' },
            { value: 'maintenance', label: 'Συντήρηση' },
            { value: 'design', label: 'Σχεδιασμός' },
            { value: 'domain', label: 'Domain' },
            { value: 'application', label: 'Εφαρμογή (SaaS)' },
            { value: 'support', label: 'Υποστήριξη' },
            { value: 'seo', label: 'SEO' },
            { value: 'consulting', label: 'Σύμβουλος' },
            { value: 'training', label: 'Εκπαίδευση' },
            { value: 'license', label: 'Άδεια Λογισμικού' },
            { value: 'other', label: 'Άλλο' }
          ]
        },
        {
          name: 'description',
          label: 'Περιγραφή',
          type: 'text',
          multiline: true,
          rows: 3,
          size: 12
        },
        {
          name: 'features',
          label: 'Χαρακτηριστικά (ένα ανά γραμμή)',
          type: 'text',
          multiline: true,
          rows: 4,
          size: 12,
          helperText: 'Συμπληρώστε κάθε χαρακτηριστικό σε ξεχωριστή γραμμή'
        }
      ]
    },
    {
      title: 'Οικονομικά Στοιχεία',
      fields: [
        {
          name: 'default_price',
          label: 'Προεπιλεγμένη Τιμή (€)',
          type: 'number',
          required: true,
          size: 6,
          step: 0.01,
          min: 0
        },
        {
          name: 'billing_period',
          label: 'Περίοδος Χρέωσης',
          type: 'select',
          size: 6,
          options: [
            { value: 'one_time', label: 'Μία φορά' },
            { value: 'monthly', label: 'Μηνιαία' },
            { value: 'quarterly', label: 'Τριμηνιαία' },
            { value: 'semi_annual', label: 'Εξαμηνιαία' },
            { value: 'annual', label: 'Ετήσια' },
            { value: 'biennial', label: 'Διετής' }
          ]
        },
        {
          name: 'is_active',
          label: 'Ενεργό Πρότυπο',
          type: 'checkbox',
          size: 6
        }
      ]
    }
  ]
};

export const updateServiceTemplateSchema = {
  ...createServiceTemplateSchema,
  // Same schema for updates
};
